import _Object$assign from "babel-runtime/core-js/object/assign";
import Vue from "vue";
import popup from "./src/popup";
var Popup = Vue.extend(popup);

var instance = new Popup();
instance.vm = instance.$mount();
document.body.appendChild(instance.vm.$el);

function init(options) {

  var defaultOptions = {
    hasMask: true,
    showPopBox: true,
    popupType: "userAuth",
    popupInner: {},
    validateButtonText: "",
    confirmedAction: function confirmedAction() {
      consoleLog("可选的确认按钮点击事件");
    },
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };

  var currentLoadingNode = document.getElementById("loadingNode");
  if (currentLoadingNode) {
    document.body.removeChild(currentLoadingNode);
  }

  return _Object$assign(defaultOptions, options);
}

Vue.prototype.popup = function (options) {
  _Object$assign(instance, init(options));
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/popup/index.js
// module id = 1572
// module chunks = 2